import {
  CREATE_PRODUCT_FAILURE,
  CREATE_PRODUCT_REQUEST,
  GET_ALL_PRODUCT_REQUEST,
  GET_ALL_PRODUCT_SUCCESS,
  GET_ALL_PRODUCT_FAILURE,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_SUCCESS,
} from "./ActionType";

const initialState = {
  products: [],
  loading: false,
  error: "",
};

export const vendorProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PRODUCT_REQUEST:
      return { ...state, loading: true };

    case CREATE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_PRODUCT_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_PRODUCT_SUCCESS:
      return { ...state, loading: false, error: "", products: action.payload };

    case GET_ALL_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_PRODUCT_REQUEST:
      return { ...state, loading: true };

    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
        products: state.products?.response?.filter(prd => prd.id !== action.payload)
      };

    case DELETE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_PRODUCT_REQUEST:
      return { ...state, loading: true };

    case UPDATE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
